<template>
  <nav-bar title="修改公司" />
  <Content :bottom="80">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getCompanyDetail"
    />
    <!-- form -->
    <van-form class="form" ref="form" @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="公司名称"
        placeholder="公司名称"
        :rules="[{ required: true, message: '请填写公司名称' }]"
      />
      <van-field
        name="socialCreditCode"
        v-model="socialCreditCode"
        label="企业统一社会信用代码："
        type="text"
        placeholder="企业统一社会信用代码或个体户注册号等"
        :rules="[{ required: true, message: '请填写公司社会信用代码' }]"
      />
      <van-field
        v-model="legalPerson"
        name="legalPerson"
        label="公司法人"
        placeholder="公司法人"
        :rules="[{ required: true, message: '请填写公司法人' }]"
      />
      <van-field
        v-model="version"
        name="version"
        label="排序"
        placeholder="排序"
        :rules="[{ required: true, message: '请填写排序' }]"
      />
      <van-field
        v-model="commodity"
        name="commodity"
        label="商品"
        placeholder="选择商品"
        is-link
        readonly
        :rules="[{ required: true, message: '请选择商品' }]"
        @click="handleCommodityClick"
      />
      <van-field
        v-model="legalPersonPhone"
        name="legalPersonPhone"
        label="公司安全负责人电话"
        placeholder="公司安全负责人电话"
        type="tel"
        :rules="[
          { validator: validatorPhone, message: '请输入正确的手机号码' }
        ]"
      />
      <van-field
        v-model="adminPhone"
        name="adminPhone"
        label="企业监管负责人电话"
        placeholder="企业监管负责人电话"
        type="tel"
        :rules="[
          { validator: validatorPhone, message: '请输入正确的手机号码' }
        ]"
      />
      <Picker
        label="街道"
        :defaultVal="streetName"
        pickerType="cascader"
        @confirm-values="(value) => (streetCode = value)"
      />
      <Picker
        label="合同过期时间"
        pickerType="time"
        :defaultVal="expTime"
        :maxDate="afterYear(5)"
        @confirm-values="(val) => (expTime = val)"
      />
      <van-field
        v-model="address"
        name="address"
        label="地址"
        placeholder="地址"
        :rules="[{ required: true, message: '请填写地址' }]"
      />
      <SelectPoint
        @get-value="selectPoint"
        :point="latitude + ',' + longitude"
      />
      <van-field
        name="isSpFill"
        :rules="[{ required: true, message: '请选择' }]"
        label="是否具备扫码充装权限"
      >
        <template #input>
          <van-radio-group v-model="isSpFill" direction="horizontal">
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
        <van-field
          name="isTest"
          :rules="[{ required: true, message: '请选择' }]"
          label="是否具备检测资质"
        >
        <template #input>
          <van-radio-group v-model="isTest" direction="horizontal">
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 人员列表 -->
      <ul class="personnel-container">
        <li class="personnel-list-item personnel-list-title">
          <div class="personnel-list-item__name">姓名</div>
          <div class="personnel-list-item__phone">电话</div>
          <div class="personnel-list-item__del"></div>
        </li>
        <li
          v-for="item in personnelList"
          :key="item"
          class="personnel-list-item van-hairline--bottom"
        >
          <div class="personnel-list-item__name">
            <van-field v-model="item.name" placeholder="姓名" readonly />
          </div>
          <div class="personnel-list-item__phone">
            <van-field v-model="item.mobile" placeholder="电话" readonly />
          </div>
          <div class="personnel-list-item__del">
            <van-button
              type="danger"
              size="mini"
              icon="delete-o"
              @click="handleDelPersonnelClick(item.id)"
              >删除</van-button
            >
          </div>
        </li>
        <!-- 列表为空 -->
        <li v-if="!personnelList.length">
          <Empty />
        </li>
      </ul>
      <div class="btn">
        <van-button
          block
          type="primary"
          plain
          size="small"
          native-type="button"
          @click="handleAddPersonnelClick"
        >
          继续添加人员
        </van-button>
      </div>
    </van-form>
  </Content>
  <div v-if="!showLoading" class="fixed-btn">
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="loading"
      :disabled="loading"
      loading-text="请稍后"
      @click="handleSubmitClick"
    >
      确认提交
    </van-button>
  </div>
  <!-- 添加人员 -->
  <add-personnel
    ref="addPersonnel"
    @submit-values="
      (values) => handleAddPersonnelSubmit({ ...values, companyId: id })
    "
  />
  <!-- 选择商品 -->
  <commodity-popup
    ref="commodityPopup"
    :commodityList="commodityList"
    @change-checked="onChangeCheked"
  />
</template>

<script>
import { ref, reactive, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getGoodsList } from '@/api/createCompany'
import {
  getDetail,
  employeeList,
  addCompanyEmp,
  delCompanyAdmin,
  updateCompany
} from '@/api/modifyCompany'
import { useAddPersonnel } from '@/hooks/useAddPersonnel'
import { useDelPersonnel } from '@/hooks/useDelPersonnel'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { useSubmit } from '@/hooks/useSubmit'
import SelectPoint from './SelectPoint.vue'
import { afterYear } from '@/utils/common'

export default {
  name: 'ModifyCompany', // 修改公司
  components: { SelectPoint },
  props: ['id'],
  setup(props) {
    const goodsId = ref([]) // 选择商品id
    const expTime = ref('')
    const formData = reactive({
      id: props.id,
      name: '',
      socialCreditCode: '',
      legalPerson: '',
      version: '',
      commodity: '',
      goodsList: [],
      longitude: 0,
      latitude: 0,
      streetCode: '',
      address: '',
      adminPhone: '',
      legalPersonPhone: '',
      isTest: '',
      isSpFill: '',
      expTime: ''
    })
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = (value) => {
      point.value = value
      formData.longitude = value[1]
      formData.latitude = value[0]
    }
    // 监听选择的商品
    watch(goodsId, (val) => {
      formData.goodsList = goodsId.value.map((item) => ({ goodsId: item }))
    })

    // 获取公司详情
    const streetName = ref('')
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getDetail,
      (data) => {
        const {
          name,
          socialCreditCode,
          legalPerson,
          version,
          goodsList,
          address,
          latitude,
          longitude,
          streetCode,
          adminPhone,
          legalPersonPhone,
          isTest,
          isSpFill
        } = data
        formData.name = name
        formData.socialCreditCode = socialCreditCode
        formData.legalPerson = legalPerson
        formData.address = address
        formData.latitude = latitude
        formData.longitude = longitude
        formData.streetCode = streetCode
        formData.adminPhone = adminPhone
        formData.legalPersonPhone = legalPersonPhone
        streetName.value = data.streetName
        formData.version = version
        formData.isTest = isTest
        formData.isSpFill = isSpFill
        expTime.value = data.expTime
        // 公司商品label值
        formData.commodity = goodsList.map((item) => item.goodsName).join(',')
        // 公司商品value值
        goodsId.value = goodsList.map((item) => item.goodsId)
        // 设置商品默认选择状态
        commodityPopup.value.checked = goodsId.value
      },
      props.id
    )
    const getCompanyDetail = getDataLoading
    getCompanyDetail()

    // 获取人员列表
    const personnelList = ref([])
    const getEmployeeList = useGetData(employeeList, (data) => {
      personnelList.value = data
    })
    getEmployeeList(props.id)

    // 获取商品列表
    const commodityList = ref([])
    const getCommodityList = useGetData(getGoodsList, (data) => {
      commodityList.value = data
    })
    getCommodityList()

    // 选择商品
    const commodityPopup = ref(null)
    const handleCommodityClick = () => {
      // 弹出商品列表
      commodityPopup.value.show = true
    }
    const onChangeCheked = ({ lable, value }) => {
      // 确认选择商品
      formData.commodity = lable.join(',')
      goodsId.value = value
    }

    // 提交表单 (修改公司)
    const router = useRouter()
    const form = ref(null)
    const handleSubmitClick = () => {
      console.log(form)
      formData.expTime = expTime.value
      form.value.submit()
    }
    const { onSubmit, loading } = useSubmit(updateCompany, formData, () => {
      router.back()
    })

    // 添加人员
    const { addPersonnel, handleAddPersonnelClick, handleAddPersonnelSubmit } =
      useAddPersonnel(addCompanyEmp, () => {
        getEmployeeList(props.id)
      })

    // 删除人员
    const { handleDelPersonnelClick } = useDelPersonnel(delCompanyAdmin, () => {
      getEmployeeList(props.id)
    })
    const validatorPhone = (val) => {
      const res =
        val === '' ||
        /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          val
        )
      return res
    }
    return {
      onSubmit,
      personnelList,
      ...toRefs(formData),
      handleSubmitClick,
      form,
      handleAddPersonnelClick,
      addPersonnel,
      handleDelPersonnelClick,
      commodityPopup,
      handleCommodityClick,
      onChangeCheked,
      commodityList,
      loading,
      getCompanyDetail,
      showLoading,
      isLoading,
      handleAddPersonnelSubmit,
      selectPoint,
      streetName,
      validatorPhone,
      expTime,
      afterYear
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 16px;
}
.btn {
  margin: 16px;
}
.personnel-container {
  background-color: #fff;
  font-size: 14px;
  .personnel-list-title {
    padding: 16px;
    background-color: #f8f8f8;
    &__name,
    &__phone {
      flex: 1;
    }
    &__del {
      width: 80px;
    }
  }
  .personnel-list-item {
    display: flex;
    align-items: center;
    &__name,
    &__phone {
      flex: 1;
    }
    &__del {
      margin-right: 16px;
    }
  }
}
.fixed-btn {
  position: absolute;
  height: 80px;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  z-index: 1;
}
</style>
